import ConfigStepPause from "../configuration/config/ConfigStepPause";
import ConfigStepMscore from "../configuration/config/ConfigStepMscore";
import PauseStepExecutor from "./executors/PauseStepExecutor";
import MscoreStepExecutor from "./executors/mscore/MscoreStepExecutor";

/**
 * Create step executor from config
 */
export default class StepExecutorFactory {

    /**
     * @param {GpsManager} gpsManager
     * @param {DeviceManager} deviceManager
     * @param {ConfigStepPause | ConfigStepMscore} stepConfig
     * @param {string} uid
     * @param {number} campaignId from configuration
     * @param {number} scenarioId identifier (should be the same for all step in a script)
     * @param {Map<string,string>} customFields A map of custom fields
     * @param {number} group identifier
     * @param {GatewayService} gateway service
     *
     * @return {PauseStepExecutor | MscoreStepExecutor | null} null if no step executor available
     */
    static getStepExecutor(gpsManager, deviceManager, stepConfig, uid, campaignId, scenarioId, customFields, groupId, gatewayService) {
        if (stepConfig instanceof ConfigStepPause) {
            return new PauseStepExecutor(stepConfig);
        } else if (stepConfig instanceof ConfigStepMscore) {
            return new MscoreStepExecutor(gpsManager, deviceManager, stepConfig, uid, campaignId, scenarioId, customFields, groupId, gatewayService);
        }

        return null;
    }
}


// WEBPACK FOOTER //
// ./js/core/script/StepExecutorFactory.js